export default __webpack_public_path__ + "static/media/ICONOS INGLÉS  MI SEGURO SOMIT -12.dce26f02.png";